import tw, { styled } from 'twin.macro';

export const StyledFooter = styled.footer`
	${tw`border-t border-gray-200`}
`;
